import React, { useContext, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import styles from "src/Assets/css/home/home.module.css";
import LeftSideBar from "../components/LeftSideBar";
import SearchResults from "../components/SearchResults";
import TrendingTags from "../components/TrendingTags";
import TrendingAsks from "../components/TrendingAsks";
import SingleTrendingTag from "../components/SingleTrendingTag";
import Content from "../components/Content";
import RightSideBar from "../components/RightSideBar";
import RestrictionMsgModal from "../../../Components/RestrictionMsgModal";
import Page, { PageEnum } from "src/layout/Page";
import GmailContactsModal from "../components/Invitations/GmailContactsModal";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import SearchPostPopup from "../components/SearchPostPopup";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Button, IconButton } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";

function ViewRenderer(props) {
  const {
    loading,
    childSaysLoading,
    feedData,
    contributors,
    trendingAsks,
    trendingTags,
    allTags,
    allTagData,
    allAsks,
    filterType,
    showData,
    selectedCommunity,
    searchData,
    followData,
    selectedTagDetails,
    showModalForUpdate,
    modalTypeForUpdate,
    childSaysData,
    answersToYourAsk,
    asksToBeAnswered,
    showHideNotifications,
    privateTagsData,
    filterPosts,
    fetchSelectedTagDetails,
    setShowData,
    goBack,
    onUpdateSelection,
    hideUpdateModal,
    fetchSearchData,
    onCommunityChange,
    fetchChildSaysData,
    postChildSayData,
    fetchFollowData,
    fetchVoteUpStatus,
    fetchSaysDataForAsks,
    fetchAsksToAnswer,
    askYourCommunity,
    fetchFeedData,
    fetchPrivateTagsData,
    deleteMessage,
    refreshFeedData,
    feedPageNumber,
    fetchPageFeed,
    value,
    changeValue,
    clearAsksAndSays,
    hasRestrictionSays,
    hasRestrictionSaysStatus,
    resetHasRestrictionSays,
    clearSearchHeader,
    deleteAnswersToAsksDialogPost,
    deletePossibleAnswerToAskPost,
    deleteAsksToBeAnsweredDialogPost,
    fetchContributors,
    landApiData,
    updateTrendingAskPageCount,
    updateTrendingTagPageCount,
    hashMoreTrendingAsks,
    hasMoreTrendingTags,
    showSearchPostPopup,
    onCloseSearchPostPopup,
    searchParam,
    possibleAsksAndAnswerLoading,
    showInviteMismatchModal,
    invitedEmail,
    loggedInEmail,
    followSuccessModal,
    followSuccessCommunityName,
    handleFollowSuccessModalClose,
    handleInviteMismatchCancel,
    handleInviteMismatchSignOut,
    showFollowHashtagAlert,
    handleFollowHashtagAlertClose,
    handlePmRoleModalClose,
    pmRoleModalOpen,
    pmRoleModalMessage
  } = props;
  const [showGmailContactsModal, setShowGmailContactsModal] = useState(false);
  const [inviteSuccessMsg, setInviteSuccessMsg] = useState("");
  const [gAuthCode, setGAuthCode] = useState("");
  const [gmailContactInviteCommunityId, setGmailContactInviteCommunityId] =
    useState(null);
  const [gmailContactInviteCommunityName, setGmailContactInviteCommunityName] =
    useState(null);
  const location = useLocation();
  const history = useHistory();
  const commonModalContext = useContext(CommonModalContext);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    const authCode = urlParams.get("code");
    const stateParam = urlParams.get("state");

    if (!authCode) {
      console.error("Authentication failed");
      return;
    }

    let tenantId = null;
    let communityName = null;

    if (stateParam) {
      try {
        const parsedState = JSON.parse(stateParam); // ✅ NO decodeURIComponent
        tenantId = parsedState?.tenantId;
        communityName = parsedState?.tenantName;
      } catch (err) {
        console.error("Failed to parse OAuth state", err);
      }
    } else {
      console.warn("OAuth state missing");
    }

    console.log("Authorization Code:", authCode);
    console.log("TenantId from OAuth state:", tenantId);

    setGAuthCode(authCode);
    setShowGmailContactsModal(true);

    if (tenantId && communityName) {
      setGmailContactInviteCommunityId(tenantId);
      setGmailContactInviteCommunityName(communityName);
    }
  }, [location.search]);

  useEffect(() => {
    history.replace("/Home");
  }, []);

  const onHashTagClick = (hashTag) => {
    if (typeof hashTag === "object") {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag: hashTag.hashtag,
        tagActivityTenantId: hashTag.tenantId,
      });
    } else {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, { hashTag });
    }
  };

  return (
    <Page
      fetchSearchData={fetchSearchData}
      filterPosts={filterPosts}
      clearSearchHeader={clearSearchHeader}
      goBack={goBack}
      page={PageEnum.Home}
      onCommunityChange={onCommunityChange}
      changeValue={changeValue}
    >
      <div className={`container ${styles.homeContainer}`}>
        <div className={`row ${styles.homeRow}`}>
          <div
            className={`col-lg-3 ${styles.leftColumn}`}
            style={{ marginTop: "8px" }}
          >
            <LeftSideBar
              onCommunityChange={onCommunityChange}
              selectedCommunity={selectedCommunity}
              setShowData={setShowData}
            />
          </div>
          {/* {showData === "search" ? (
            <div className={`col-lg-6 ${styles.midColumn}`} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
              <SearchResults
                loading={loading}
                childSaysLoading={childSaysLoading}
                searchData={searchData}
                goBack={goBack}
                childSaysData={childSaysData}
                fetchChildSaysData={fetchChildSaysData}
                postChildSayData={postChildSayData}
                fetchFollowData={fetchFollowData}
                fetchVoteUpStatus={fetchVoteUpStatus}
                fetchFeedData={fetchFeedData}
                deleteMessage={deleteMessage}
                refreshFeedData={refreshFeedData}
                fetchContributors={fetchContributors}
                onHashTagClick={onHashTagClick}
              />
            </div>
          ) :  */}
          {showData === "tag" ? (
            <div
              className={`col-lg-6 ${styles.midColumn}`}
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <TrendingTags
                loading={loading}
                childSaysLoading={childSaysLoading}
                postChildSayData={postChildSayData}
                fetchFeedData={fetchFeedData}
                allTags={allTags}
                allTagData={allTagData}
                goBack={goBack}
                childSaysData={childSaysData}
                fetchChildSaysData={fetchChildSaysData}
                deleteMessage={deleteMessage}
                fetchFollowData={fetchFollowData}
                fetchVoteUpStatus={fetchVoteUpStatus}
                refreshFeedData={refreshFeedData}
                showData={showData}
                hasRestrictionSays={hasRestrictionSays}
                fetchContributors={fetchContributors}
                onHashTagClick={onHashTagClick}
                updateTrendingTagPageCount={updateTrendingTagPageCount}
                hasMoreTrendingTags={hasMoreTrendingTags}
              />
            </div>
          ) : showData === "ask" ? (
            <div
              className={`col-lg-6 ${styles.midColumn}`}
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <TrendingAsks
                childSaysLoading={childSaysLoading}
                postChildSayData={postChildSayData}
                fetchFeedData={fetchFeedData}
                loading={loading}
                allAsks={allAsks}
                goBack={goBack}
                childSaysData={childSaysData}
                fetchChildSaysData={fetchChildSaysData}
                deleteMessage={deleteMessage}
                fetchFollowData={fetchFollowData}
                fetchVoteUpStatus={fetchVoteUpStatus}
                refreshFeedData={refreshFeedData}
                showData={showData}
                fetchContributors={fetchContributors}
                onHashTagClick={onHashTagClick}
                updateTrendingAskPageCount={updateTrendingAskPageCount}
                hashMoreTrendingAsks={hashMoreTrendingAsks}
              />
            </div>
          ) : showData === "singleTrendingTag" ? (
            <div
              className={`col-lg-6 ${styles.midColumn}`}
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <SingleTrendingTag
                loading={loading}
                childSaysLoading={childSaysLoading}
                postChildSayData={postChildSayData}
                fetchFeedData={fetchFeedData}
                allTags={selectedTagDetails}
                goBack={goBack}
                childSaysData={childSaysData}
                fetchChildSaysData={fetchChildSaysData}
                deleteMessage={deleteMessage}
                fetchFollowData={fetchFollowData}
                fetchVoteUpStatus={fetchVoteUpStatus}
                refreshFeedData={refreshFeedData}
                showData={showData}
                hasRestrictionSays={hasRestrictionSays}
                fetchContributors={fetchContributors}
                onHashTagClick={onHashTagClick}
              />
            </div>
          ) : (
            <div
              className={`col-lg-6 ${styles.midColumn}`}
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <Content
                loading={loading}
                childSaysLoading={childSaysLoading}
                feedData={feedData}
                filterPosts={filterPosts}
                filterType={filterType}
                followData={followData}
                privateTagsData={privateTagsData}
                answersToYourAsk={answersToYourAsk}
                asksToBeAnswered={asksToBeAnswered}
                childSaysData={childSaysData}
                fetchSaysDataForAsks={fetchSaysDataForAsks}
                fetchAsksToAnswer={fetchAsksToAnswer}
                askYourCommunity={askYourCommunity}
                fetchFeedData={fetchFeedData}
                fetchChildSaysData={fetchChildSaysData}
                postChildSayData={postChildSayData}
                fetchFollowData={fetchFollowData}
                fetchVoteUpStatus={fetchVoteUpStatus}
                fetchPrivateTagsData={fetchPrivateTagsData}
                deleteMessage={deleteMessage}
                refreshFeedData={refreshFeedData}
                feedPageNumber={feedPageNumber}
                fetchPageFeed={fetchPageFeed}
                value={value}
                changeValue={changeValue}
                clearAsksAndSays={clearAsksAndSays}
                deleteAnswersToAsksDialogPost={deleteAnswersToAsksDialogPost}
                deletePossibleAnswerToAskPost={deletePossibleAnswerToAskPost}
                deleteAsksToBeAnsweredDialogPost={
                  deleteAsksToBeAnsweredDialogPost
                }
                fetchContributors={fetchContributors}
                onHashTagClick={onHashTagClick}
                landApiData={landApiData}
                possibleAsksAndAnswerLoading={possibleAsksAndAnswerLoading}
              />
            </div>
          )}
          <div
            className={`col-lg-3 ${styles.rightColumn}`}
            style={{ marginTop: "8px" }}
          >
            <RightSideBar
              contributorsData={contributors}
              trendingTags={trendingTags}
              trendingAsks={trendingAsks}
              setShowData={setShowData}
              showModal={showModalForUpdate}
              modalType={modalTypeForUpdate}
              fetchSelectedTagDetails={fetchSelectedTagDetails}
              onUpdateSelection={onUpdateSelection}
              hideUpdateModal={hideUpdateModal}
              fetchFeedData={fetchFeedData}
              filterPosts={filterPosts}
              changeValue={changeValue}
              showData={showData}
              fetchContributors={fetchContributors}
              selectedCommunity={selectedCommunity}
              pageType={"homePage"}
            />
          </div>
        </div>
      </div>

      <RestrictionMsgModal
        open={hasRestrictionSays}
        onClose={resetHasRestrictionSays}
        title="Thank you"
        message={`Your ${
          hasRestrictionSaysStatus === "E_Say" ? "Answer" : "Reply"
        } will publish as soon as the Community Moderator approves it.`}
      />

      <ConfirmationDialog
        open={showInviteMismatchModal}
        handleClose={() => {
          console.log("Invite mismatch modal closed");
        }}
        // title={`You got an invitation for ${invitedEmail}, but you signed in with ${loggedInEmail}.`}
        title={{
          status: (
            <>
              <strong>Different Account</strong>
              <br />
              <br />
              You are currently signed in as <strong>{loggedInEmail}</strong>.
              <br />
              <br />
              This invitation is for <strong>{invitedEmail}</strong>.
              <br />
              <br />
              Please sign out before accepting this invitation.
            </>
          ),
        }}
        rejectLabel="Cancel"
        onReject={handleInviteMismatchCancel}
        acceptLabel="Sign Out"
        onAccept={handleInviteMismatchSignOut}
        type="info"
      />

      <ConfirmationDialog
        open={showFollowHashtagAlert}
        handleClose={handleFollowHashtagAlertClose}
        title="You are now following this hashtag"
        acceptLabel="OK"
        onAccept={handleFollowHashtagAlertClose}
        type="success"
      />

      <ConfirmationDialog
        open={pmRoleModalOpen}
        handleClose={handlePmRoleModalClose}
        title={pmRoleModalMessage}
        type="success"
        acceptLabel="OK"
        onAccept={handlePmRoleModalClose}
      />

      {showGmailContactsModal && gAuthCode && (
        <GmailContactsModal
          open={showGmailContactsModal}
          handleClose={() => {
            setShowGmailContactsModal(false);
            setGAuthCode(null);
          }}
          onSuccess={(res) => {
            setShowGmailContactsModal(false);
            setGAuthCode(null);
            setInviteSuccessMsg(res);
          }}
          authCode={gAuthCode}
          communityId={gmailContactInviteCommunityId}
          communityName={gmailContactInviteCommunityName}
        />
      )}

      {inviteSuccessMsg && (
        <ConfirmationDialog
          open={!!inviteSuccessMsg}
          handleClose={() => {
            setInviteSuccessMsg("");
            setShowGmailContactsModal(false);
            setGAuthCode(null);
            history.replace("/Home");
          }}
          title={inviteSuccessMsg}
          acceptLabel="Ok"
          onAccept={() => {
            setInviteSuccessMsg("");
            setShowGmailContactsModal(false);
            setGAuthCode(null);
            history.replace("/Home");
          }}
          type="info"
        />
      )}

      {searchParam && showSearchPostPopup && (
        <SearchPostPopup
          open={showSearchPostPopup}
          onClose={onCloseSearchPostPopup}
          searchParam={searchParam}
          onHashTagClick={(hashTag) => {
            // onCloseSearchPostPopup && onCloseSearchPostPopup();
            onHashTagClick(hashTag);
          }}
        />
      )}
      <Modal
        open={followSuccessModal}
        onClose={handleFollowSuccessModalClose}
        aria-labelledby="follow-success-modal-title"
        sx={{
          zIndex: 12000,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            maxWidth: "90%",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: 24,
            p: 3,
            outline: "none",
          }}
        >
          <IconButton
            onClick={handleFollowSuccessModalClose}
            sx={{
              position: "absolute !important",
              top: "8px !important",
              right: "8px !important",
              left: "auto !important",
              bottom: "auto !important",
              zIndex: 10,
            }}
          >
            <IoIosCloseCircleOutline />
          </IconButton>

          <Box
            id="follow-success-modal-title"
            sx={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: 600,
              padding: "20px 30px 15px",
            }}
          >
            You are now following {followSuccessCommunityName}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Button
              variant="contained"
              onClick={handleFollowSuccessModalClose}
              sx={{
                backgroundColor: "#1976d2 !important",
                color: "#ffffff !important",
                textTransform: "uppercase",
                fontWeight: 600,
                fontSize: "14px",
                padding: "6px 24px",
                borderRadius: "4px",
                boxShadow:
                  "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12) !important",
                "&:hover": {
                  backgroundColor: "#1565c0 !important",
                },
              }}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    </Page>
  );
}

export default ViewRenderer;
